import { create } from 'zustand';

/**
 * Cache for catalog/dashboard widgets whose data lives on a domain stats
 * endpoint (BCM, unit, asset, incident, GDPR, vendor, license, disposal).
 */
export const useWidgetPageStatsStore = create((set) => ({
    slices: {},
    loading: {},
    errors: {},
    loadedAt: {},

    setSlice: (section, data) => set((state) => ({
        slices: { ...state.slices, [section]: data },
    })),

    setLoading: (section, loading) => set((state) => ({
        loading: { ...state.loading, [section]: loading },
    })),

    setError: (section, error) => set((state) => ({
        errors: { ...state.errors, [section]: error },
    })),

    markLoaded: (section, timestamp = Date.now()) => set((state) => ({
        loadedAt: { ...state.loadedAt, [section]: timestamp },
    })),

    invalidate: (section) => set((state) => {
        const loadedAt = { ...state.loadedAt };
        delete loadedAt[section];
        return { loadedAt };
    }),

    reset: () => set({ slices: {}, loading: {}, errors: {}, loadedAt: {} }),
}));
